export default {
  dashboardData: {
    isSidebarActive: false,
    notificationsNumber: 0,
  },

  chatList: {
    open: false,
  },
  profileDropDown: {
    open: false,
  },

  moneyTransfer: {
    step: 1,
  },
  creditCard: {
    step: 1,
  },

  contactActions: {
    isSendingCash: false,
    isSendingMoney: true,
    isManagingContacts: false,
    isTopingUp: false,
    isSendingOthers: false,
    isSendingVoucher: false,
  },
};
